import { Component, OnInit } from '@angular/core';
import { DatosService } from '../servicios/datos.service';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {

  constructor(
    public _datosService : DatosService
  ){}

  ngOnInit(){}
  
  servicesTile  = this._datosService.servicesTile

}
